import $ from './el.JsModules.js';

const SELECTOR = {
  //PRODUCT MEDIA
  IMAGE: `[data-image-alt]`,
  IMAGE_BY_ALT: (alt) => `[data-image-alt="${alt}"]`,
  //PRODUCT INFO
  PDP_INFO_CONTAINER: '[data-pdp-info]',
  AJAX_RERENDER: '[data-ajax-rerender]',
  AJAX_RERENDER_BY_VALUE: (val) => `[data-ajax-rerender="${val}"]`,
  OPTION_INPUT: '.js-el-pdp-hero__input',
  QTY_BTN: '.qty-selector__button',
  QTY_INPUT: '.qty-selector__input',
  //PRODUCT INVENTORY
  LOCATION_TRIGGER: '[data-location-trigger]',
  INVENTORY_BY_VAR_ID: (varinatId) => `[data-inventory-by-variant-id="${varinatId}"]`,
  SELECTED_VARIANT_LOCATION_BY_ID: (locationId) => `[data-location-id="${locationId}"]`,
  LOCATION_IN_STOCK: '.js-location-inventory-in-stock',
  LOCATION_OUT_OF_STOCK: '.js-location-inventory-out-of-stock',
};

elabs.PdpHero = class {
  'use strict';

  constructor(element) {
    this.globalListeners();
    this.view = $(element);

    //CONFIG
    this.sectionId = this.view.data('section-id');
    this.optionNamesForFilteringProductMedia = this.view
      .data('option-names-for-filtering-product-media')
      .split(',')
      .map((optionName) => optionName.trim().toLowerCase());
    const { product, productOptions, selectedVariant } = JSON.parse(
      this.view.find(`#product-json-${this.sectionId}`).text(),
    );
    this.product = product;
    this.productOptions = productOptions;
    this.selectedVariant = selectedVariant;
    this.quantityRule = selectedVariant.quantity_rule;

    this.product.variants.length > 1 && this.changeURL(selectedVariant);

    //INIT FN's
    this.initSlider({ productOptions, selectedVariant });

    //Listeners
    this.initEventListeners();
  }

  //PRODUCT MEDIA
  filterProductImages({ productOptions, selectedVariant }) {
    const option = productOptions.find((option) => {
      const optionName = option.name.toLowerCase();
      return this.optionNamesForFilteringProductMedia.includes(optionName);
    });

    if (option) {
      const { position } = option;
      const optionValue = selectedVariant.options[position - 1];
      const imagesByAlt = this.view.find(SELECTOR.IMAGE_BY_ALT(optionValue));

      if (imagesByAlt.length > 0) {
        this.view.find(SELECTOR.IMAGE).hide();
        imagesByAlt.show();
        return;
      }

      this.view.find(SELECTOR.IMAGE).show();
      return;
    }

    this.view.find(SELECTOR.IMAGE).show();
  }
  initSlider({ productOptions, selectedVariant }) {
    this.filterProductImages({ productOptions, selectedVariant });

    this.swiperSlider = new Swiper(this.view.find('.el-pdp-hero__mobile-media')[0], {
      slidesPerView: 1,
      observer: true,
      pagination: {
        clickable: true,
        el: '.swiper-pagination',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true, // Only enable keyboard control when the slider is in the viewport
      },
    });
  }

  async init() {
    const url = `https://services.one.world/stock-checker/${this.product.id}`;
    const res = await fetch(url);
    const data = await res.json();
    let { variants } = this.normalizeVariantLocations(data);
    const locations = await elabs.Utils.getStoreLocations();
    let activeLocation = locations.find((location) => location?.primary) || locations[0];

    // ✅ Защита от отсутствия локаций
    if (!activeLocation) {
      console.warn('No available locations');
      return;
    }

    // CHECK Availability in primary location
    const someAvailableInActiveLocation = this.checkIfSomeVariantAvailableInActiveLocation({
      activeLocation,
      variantsWithInventory: variants,
    });

    // CHECK Availability in any location
    const possibleLocationIndex = locations.findIndex((loc) =>
      loc
        ? this.checkIfSomeVariantAvailableInActiveLocation({
            activeLocation: loc,
            variantsWithInventory: variants,
          })
        : false,
    );

    if (!someAvailableInActiveLocation) {
      if (possibleLocationIndex !== -1) {
        activeLocation = locations[possibleLocationIndex];
      } else {
        this.view.find(SELECTOR.LOCATION_IN_STOCK).addClass('hidden');
        this.view.find(SELECTOR.LOCATION_OUT_OF_STOCK).removeClass('hidden');
      }
    }

    this.locationData = data;
    this.locations = locations;
    this.variantsWithInventory = variants;
    this.activeLocation = activeLocation;

    this.setInventoryToVariants({ activeLocation, variantsWithInventory: variants });
    this.setLocationTrigger(activeLocation);

    this.setInventoryForStockChecker();
  }

  checkIfSomeVariantAvailableInActiveLocation({ activeLocation, variantsWithInventory }) {
    if (!activeLocation || !activeLocation.id) {
      console.warn('No activeLocation provided');
      return false;
    }

    const activeLocationId = String(activeLocation.id);

    for (const variantId in variantsWithInventory) {
      const inventories = variantsWithInventory[variantId];

      const match = inventories.find((entry) => String(entry.locationId) === activeLocationId && entry.quantity > 0);

      if (match) return true;
    }

    return false;
  }

  async fetchData(url) {
    try {
      const res = await fetch(url);
      const data = await res.json();

      return data;
    } catch (e) {
      throw new Error(e);
    }
  }

  normalizeVariantLocations(data) {
    const allLocationIds = data.locations.map((loc) => String(loc.id)); // Получаем все ID как строки

    const variants = data.variants;

    for (const variantId in variants) {
      const variantLocations = variants[variantId];

      const existingLocationIds = variantLocations.map((v) => String(v.locationId));

      const missingLocationIds = allLocationIds.filter((id) => !existingLocationIds.includes(id));

      missingLocationIds.forEach((missingId) => {
        variantLocations.push({
          locationId: missingId,
          quantity: 0,
        });
      });
    }

    return data;
  }

  changeLocationById(id) {
    this.activeLocation = this.locationData.locations.find((location) => location.id === id);
    this.setInventoryToVariants({
      activeLocation: this.activeLocation,
      variantsWithInventory: this.variantsWithInventory,
    });
  }

  setInventoryToVariants({ activeLocation, variantsWithInventory }) {
    for (const [variatnId, value] of Object.entries(variantsWithInventory)) {
      const { quantity } = value.find((inventory) => inventory.locationId === activeLocation.id);

      const parentEl = this.view.find(SELECTOR.INVENTORY_BY_VAR_ID(variatnId));
      const inStockEl = parentEl.find('[data-dynamic-in-stock]');

      inStockEl.attr('data-dynamic-in-stock', Boolean(quantity));
      inStockEl.html(quantity === 0 ? 'Not currently stocked at this location' : 'In stock');
    }
  }

  setInventoryForStockChecker() {
    const locations = this.locations;
    const variantsWithInventory = this.variantsWithInventory;
    const variants = this.product.variants;

    locations.forEach((location) => {
      const locationId = location.id;
      const el = $(SELECTOR.SELECTED_VARIANT_LOCATION_BY_ID(locationId));
      let template = '';
      variants.forEach((variant) => {
        const inventory = variantsWithInventory[variant.id].find((inventory) => inventory.locationId === locationId);
        let stockMessage = inventory.quantity > 0 ? `In stock` : 'Not currently stocked at this location';
        template += `<span>${this.product.title}${variant.title !== 'Default Title' ? ` - ${variant.title}` : ''}: <strong class="el-stock-count ${inventory.quantity <= 0 && 'out-of-stock'}">${stockMessage}</strong></span>`;
      });

      if (el.length > 0) {
        el.html(template);
      }
    });
  }

  setLocationTrigger(activeLocation) {
    const locationTriggerEl = this.view.find(SELECTOR.LOCATION_TRIGGER);
    const locationNameEl = locationTriggerEl.find('[data-location-name]');

    locationNameEl.html(activeLocation.name);

    locationTriggerEl.on('click', () => {
      window.stockChecker.show();
    });
  }

  changeURL(selectedVariantId) {
    history.pushState(null, '', `/products/${this.product.handle}?variant=${selectedVariantId.id}`);
  }

  async getProductSection(selectedVariant) {
    const url = `/products/${this.product.handle}?variant=${selectedVariant.id}&sections=${this.sectionId}`;
    $(SELECTOR.PDP_INFO_CONTAINER).toggleClass('not-editable');
    const data = await this.fetchData(url);

    const parser = new DOMParser();
    const doc = parser.parseFromString(data[this.sectionId], 'text/html');

    $(SELECTOR.AJAX_RERENDER).each((index, element) => {
      const val = $(element).attr('data-ajax-rerender');
      const selector = SELECTOR.AJAX_RERENDER_BY_VALUE(val);
      const newEl = doc.querySelector(selector);
      element.className = '';
      newEl.classList.forEach((cls) => element.classList.add(cls));
      $(element).html($(newEl).html());
    });

    this.initEventListeners();
    $(SELECTOR.PDP_INFO_CONTAINER).toggleClass('not-editable');
    this.reinitTrustpilot();
  }

  initEventListeners() {
    const optionInputs = this.view.find(SELECTOR.OPTION_INPUT);
    const qtyBtns = this.view.find(SELECTOR.QTY_BTN);
    const _qtyInput = this.view.find(SELECTOR.QTY_INPUT);

    //PRODUCT OPTIONS
    optionInputs.each((index, element) => {
      $(element).on('input', () => {
        $(element).prop('checked', true);
        const allInputs = optionInputs.filter(':checked');
        const currentOptions = allInputs.map((index, element) => element.value).get();

        const selectedVariant = this.product.variants.find((variant) =>
          currentOptions.every((value) => variant.options.includes(value)),
        );

        this.selectedVariant = selectedVariant;

        this.filterProductImages({ productOptions: this.productOptions, selectedVariant });

        this.changeURL(selectedVariant);
        this.getProductSection(selectedVariant);

        const optionName = $(element).data('option-name').toLowerCase();
        const clickedOptionSortImages = this.optionNamesForFilteringProductMedia.includes(optionName);

        if (clickedOptionSortImages) {
          window.outerWidth <= 767 && window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    });

    //PRODUCT QUANTITY
    qtyBtns.each((index, element) => {
      $(element).on('click', () => {
        const qtyInput = $(_qtyInput);
        const qtyInputValue = $(qtyInput).val();
        const allStock = parseInt($(qtyInput).data('all-stock'));
        const step = parseInt($(qtyInput).attr('step'));
        const max = $(qtyInput).attr('max') ? parseInt($(qtyInput).attr('max')) : allStock;
        const val = $(element).data('type') === 'decrease' ? -1 * step : 1 * step;
        const newQty = Number(qtyInputValue) + val;

        if (newQty === 0) return;

        switch (true) {
          case newQty >= max:
            $(qtyInput).val(Math.floor(max / step) * step);
            break;
          default:
            $(qtyInput).val(newQty);
        }
      });
    });

    $(_qtyInput).on('blur', (e) => {
      const qtyInput = $(e.target);
      const step = parseInt(qtyInput.attr('step')) || 1;
      const max = qtyInput.attr('max') ? parseInt(qtyInput.attr('max')) : parseInt(qtyInput.data('all-stock'));
      const min = parseInt(qtyInput.attr('min')) || step;

      let currentValue = parseInt(qtyInput.val()) || 0;

      const maxUnits = Math.floor(max / step);
      const minUnits = Math.ceil(min / step);

      const enteredUnits = Math.round(currentValue / step);
      let adjustedUnits = enteredUnits;

      if (enteredUnits > maxUnits) {
        adjustedUnits = maxUnits;
      } else if (enteredUnits < minUnits) {
        adjustedUnits = minUnits;
      }

      const newQty = adjustedUnits * step;

      if (newQty !== currentValue) {
        qtyInput.val(newQty);
      }
    });
  }

  reinitTrustpilot() {
    if (window.Trustpilot) {
      console.log(`reinitTrustpilot`, { Trustpilot: window.Trustpilot });
      this.view.find('.trustpilot-widget').each((index, el) => {
        window.Trustpilot.loadFromElement(el);
      });
    }
  }

  globalListeners() {
    subscribe(PUB_SUB_EVENTS.cartError, (data) => {
      elabs.Utils.showToast(`There was a problem adding to the cart:<br/> ${data.message}`);
    });
  }
};

// Init
elabs.onJavascriptReady(function () {
  $('.el-pdp-hero').each(function (index, element) {
    const pdpHero = new elabs.PdpHero(element);
    pdpHero.init();
  });
});
